module.exports = __webpack_public_path__ + "img/1271c9e6faf46fdcb7623396fa8e964c.png";